import { StyleSheet } from 'react-native'

import { BottomSheetScrollView } from '@gorhom/bottom-sheet'
import LazyHOC from '@zet/common/components/lazyHoc'
import {
  B4,
  B5,
  BottomSheet,
  Button,
  H6,
  Stack,
  XStack,
} from '@zet/design-system'
import { useLoyaltyPayoutMeta } from '@zet/feature-loyalty'
import { i18n } from '@zet/localization'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'

import { useBrandDetailsById } from '../../api/brands/hooks'
import ZetSalesGenius from '../../assets/svg/zetSalesGenius.svg'
import { PayoutTable } from '../payoutTable'
import { TierCardList } from './tierCardList'

const HighestPayouBottomsheet = ({
  isBottomSheetVisible,
  setIsBottomSheetVisible,
  categoryId,
  commission,
  brandName,
  tier,
  tierData,
  partnerId,
  partnerCategoryId,
}: {
  isBottomSheetVisible: boolean
  setIsBottomSheetVisible: React.Dispatch<React.SetStateAction<boolean>>
  categoryId?: string | number
  commission?: string
  brandName?: string
  tier: any
  tierData: any
  partnerId?: number | string
  partnerCategoryId?: number
}) => {
  const { computeHighestPayout, handleExtraPayoutColumn } =
    useLoyaltyPayoutMeta({
      partnerId,
      partnerCategoryId,
      isHighestLoyaltyPayout: true,
      payoutContent: commission,
    })
  function closeBottomsheet() {
    setIsBottomSheetVisible(false)
  }
  const { data: content } = useBrandDetailsById(partnerId || '')

  const payoutContent =
    content?.payoutDetails?.[Object.keys(content?.payoutDetails)?.[0]][0]
  const payoutText =
    payoutContent?.prefix + payoutContent?.value + payoutContent?.suffix || ''

  return (
    <BottomSheet
      visible={isBottomSheetVisible}
      onDismiss={closeBottomsheet}
      bodyStyle={styles.bottomsheetStyling}
      sheetName="payout_info"
      disableBottomSheet={closeBottomsheet}
    >
      <LazyHOC>
        <BottomSheetScrollView
          className=""
          style={styles.BottomSheetScrollViewHeight}
        >
          <H6 className="text-tertiary-200 mt-2 text-center">{brandName}</H6>
          <H6 className="text-tertiary-200 mb-3 mt-2 text-center">
            {!handleExtraPayoutColumn()
              ? i18n.t('brandDetails.flat', {
                  amount: computeHighestPayout(),
                })
              : i18n.t('brandDetails.earnUpto', {
                  amount: computeHighestPayout(),
                })}
          </H6>

          <PayoutTable
            categoryId={categoryId}
            commission={commission}
            tier={tier}
            tierData={tierData}
            partnerId={partnerId}
            partnerCategoryId={partnerCategoryId}
          />
          {payoutText && <B4 className="ml-2 mt-1">{payoutText}</B4>}
          <XStack className="mb-2 mt-4 items-center justify-center">
            <ZetSalesGenius />
            <H6 className="text-tertiary-200 ml-2">
              {i18n.t('brandDetails.howToBe')}
            </H6>
          </XStack>
          <B4 className="text-grays-70 mx-3 mb-2 text-center">
            {i18n.t('brandDetails.completeSalesTarget')}
          </B4>
          <TierCardList tier={tier} tierData={tierData} />
          <B5 className="text-grays-70 mx-3">
            {i18n.t('brandDetails.higherPayoutOnly')}
          </B5>
          <Stack className="h-5"></Stack>
        </BottomSheetScrollView>
        <Stack className="border-grays-30 bg-neutral-white100 w-full border-t px-3 py-2">
          <Button className="w-full" onPress={closeBottomsheet}>
            {i18n.t('brandDetails.gotIt')}
          </Button>
        </Stack>
      </LazyHOC>
    </BottomSheet>
  )
}

export default HighestPayouBottomsheet
const styles = StyleSheet.create({
  BottomSheetScrollViewHeight: {
    height: DEVICE_HEIGHT,
  },
  bottomsheetStyling: {
    position: 'relative',
    height: DEVICE_HEIGHT * 0.9,
  },
})
